import React from "react";
import useTranslation from "../../../hooks/useTranslation";

export default function AddDoctorModal({ show, onClose, doctorForm, setDoctorForm, onSubmit }) {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{t('Add New Doctor')}</h2>
        <form onSubmit={onSubmit}>
          <div className="admin-row">
            <label>{t('Name')} *</label>
            <input type="text" required value={doctorForm.name} onChange={(e) => setDoctorForm({...doctorForm, name: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>{t('Email')} *</label>
            <input type="email" required value={doctorForm.email} onChange={(e) => setDoctorForm({...doctorForm, email: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>{t('Phone')}</label>
            <input type="text" value={doctorForm.phone} onChange={(e) => setDoctorForm({...doctorForm, phone: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>{t('Display Name')}</label>
            <input type="text" value={doctorForm.display_name} onChange={(e) => setDoctorForm({...doctorForm, display_name: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>{t('Age')}</label>
            <input type="number" value={doctorForm.age} onChange={(e) => setDoctorForm({...doctorForm, age: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>{t('Gender')}</label>
            <select value={doctorForm.gender} onChange={(e) => setDoctorForm({...doctorForm, gender: e.target.value})}>
              <option value="">{t('Select')}</option>
              <option value="Male">{t('Male')}</option>
              <option value="Female">{t('Female')}</option>
              <option value="Other">{t('Other')}</option>
            </select>
          </div>
          <div className="admin-row">
            <label>{t('Role/Specialization')}</label>
            <input type="text" value={doctorForm.role_specialization} onChange={(e) => setDoctorForm({...doctorForm, role_specialization: e.target.value})} placeholder={t("e.g., Psychiatrist, Psychologist, Therapist")} />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <button type="submit" className="btn btn-primary">{t('Create Doctor')}</button>
            <button type="button" className="btn" onClick={onClose}>{t('Cancel')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
